import Vue from 'vue'
import App from './App.vue'
import VueScroller from 'vue-scroller';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import language from './tools/language.js';
Vue.prototype.$language = language;

import Util from './tools/Util.js';
Vue.prototype.$Util = Util;


Vue.config.productionTip = true
Vue.use(ElementUI);
Vue.use(VueScroller);

new Vue({
  render: h => h(App),
}).$mount('#app')
